const MINIMUM_NAV_GAP = 80;
const MOBILE_NAV_MAX = 767;
const RESPONSIVE_NAV_SELECTOR = ".navbar[data-responsive-nav]";

function expandedWidth(nav) {
  const clone = nav.cloneNode(true);

  clone.removeAttribute("id");
  clone.classList.remove("navbar--fit-collapsed");
  clone.classList.add("navbar--fit-expanded", "navbar--measuring");
  document.body.appendChild(clone);

  const header = clone.querySelector(".navbar-header");
  const collapse = clone.querySelector(".navbar-collapse");
  const styles = window.getComputedStyle(clone);
  const requiredWidth =
    header.getBoundingClientRect().width +
    collapse.getBoundingClientRect().width +
    parseFloat(styles.paddingLeft || 0) +
    parseFloat(styles.paddingRight || 0) +
    MINIMUM_NAV_GAP;

  clone.parentNode.removeChild(clone);
  return Math.ceil(requiredWidth);
}

function fitNav(nav) {
  // clientWidth excludes the vertical scrollbar. innerWidth includes it,
  // which made the expanded-side gap about 15px smaller than the promised
  // 80px on pages tall enough to scroll.
  const availableWidth = document.documentElement.clientWidth;
  const expanded = availableWidth > MOBILE_NAV_MAX &&
    availableWidth >= expandedWidth(nav);

  nav.classList.toggle("navbar--fit-expanded", expanded);
  nav.classList.toggle("navbar--fit-collapsed", !expanded);

  if (expanded) {
    const collapse = nav.querySelector(".navbar-collapse");
    if (collapse) collapse.classList.remove("show");
  }
}

let animationFrame;

function eachNav(callback) {
  Array.prototype.forEach.call(
    document.querySelectorAll(RESPONSIVE_NAV_SELECTOR),
    callback
  );
}

function fitResponsiveNavs() {
  window.cancelAnimationFrame(animationFrame);
  animationFrame = window.requestAnimationFrame(() => {
    eachNav(fitNav);
  });
}

function whenPackCssReady(callback) {
  const pending = window.paythenPackCss;
  if (pending && typeof pending.then === "function") {
    pending.then(callback, callback);
  } else {
    callback();
  }
}

function fitWhenCssReady() {
  whenPackCssReady(fitResponsiveNavs);
}

document.addEventListener("paythen:pack-css-ready", fitWhenCssReady);
document.addEventListener("turbolinks:load", fitWhenCssReady);
window.addEventListener("resize", fitWhenCssReady);
window.addEventListener("load", fitWhenCssReady);

if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(fitWhenCssReady);
}

let lastLayoutWidth;
if (typeof ResizeObserver !== "undefined") {
  const layoutObserver = new ResizeObserver(() => {
    const width = document.documentElement.clientWidth;
    if (width === lastLayoutWidth) return;
    lastLayoutWidth = width;
    fitWhenCssReady();
  });
  layoutObserver.observe(document.documentElement);
}

if (typeof MutationObserver !== "undefined") {
  // The observer is attached to responsive navs only, so any mutation it
  // receives already belongs to one. `closest` is skipped where it is
  // missing (IE11 has MutationObserver but not Element.closest).
  const navObserver = new MutationObserver((mutations) => {
    if (mutations.some((mutation) =>
      !mutation.target.closest ||
      mutation.target.closest(RESPONSIVE_NAV_SELECTOR)
    )) {
      fitWhenCssReady();
    }
  });

  document.addEventListener("turbolinks:load", () => {
    navObserver.disconnect();
    eachNav((nav) => {
      navObserver.observe(nav, {
        attributes: true,
        attributeFilter: ["class", "style"],
        childList: true,
        subtree: true
      });
    });
  });
}
